import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { BorisScreener } from '@/shared/borisScreenerTheme';

type ProgressBarProps = {
  progress: number;
  current: number;
  total: number;
};

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

const Segment = styled.span<{ $isCompleted: boolean }>`
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background-color: ${({ $isCompleted }) =>
    $isCompleted ? BorisScreener.dashFill : BorisScreener.dashTrack};
  transition: background-color 0.3s ease;
`;

const ProgressBar = ({ current, total }: ProgressBarProps) => {
  const { t } = useTranslation();

  return (
    <ProgressBarContainer
      aria-label={t('numbers.step-out-of', { X: current, Y: total })}
      tabIndex={0}
    >
      {Array.from({ length: total }, (_, index) => (
        <Segment
          key={index}
          $isCompleted={index < current}
          aria-hidden="true"
        />
      ))}
    </ProgressBarContainer>
  );
};

export { ProgressBar };
